/* global chrome */
// const EXTENSION_ID = "gnhoedmgmepgeibnjkganjadamgblemk";
const EXTENSION_ID = "bpadafeoianlahndcblhnljocopdeaak"; // Replace with actual ID

export function callApiThroughExtension({
  url,
  request_type = "GET",
  params = [],
  headers = [],
  body = {},
  body_type = "raw",
  authorization_type,
  authorization_value,
}) {
  return new Promise((resolve, reject) => {
    if (
      typeof chrome === "undefined" ||
      typeof chrome?.runtime === "undefined" ||
      typeof chrome?.runtime?.sendMessage !== "function"
    ) {
      console.error("chrome.runtime.sendMessage is not available.");
      return reject("chrome.runtime.sendMessage is not available.");
    }
    chrome.runtime.sendMessage(
      EXTENSION_ID,
      {
        type: "fetch_api",
        payload: {
          url,
          request_type,
          params,
          headers,
          body,
          body_type,
          authorization_type,
          authorization_value,
        },
      },
      (response) => {
        if (chrome.runtime.lastError) {
          reject(chrome.runtime.lastError.message);
        } else if (response && response.success) {
          resolve(response);
        } else {
          reject(response?.error || "Unknown error");
        }
      }
    );
  });
}

export function checkExtensionInstalled(timeoutMs = 500) {
  return new Promise((resolve) => {
    let resolved = false;

    function handler(event) {
      console.log(event.data);
      // Ignore any other messages
      if (event.source !== window) return;
      if (!event.data || typeof event.data !== "object") return;

      // Only handle our specific message
      if (event.data.type === "QODEX_EXTENSION_STATUS") {
        resolved = true;
        resolve(event.data.installed);
        window.removeEventListener("message", handler);
      }
    }

    window.addEventListener("message", handler);
    window.postMessage({ type: "CHECK_QODEX_EXTENSION" }, "*");

    setTimeout(() => {
      if (!resolved) {
        window.removeEventListener("message", handler);
        resolve(false);
      }
    }, timeoutMs);
  });
}

(async () => {
  const installed = await checkExtensionInstalled();
})();
